// TRENDING SEARCHES
async function fetchTrendingSearches() {
  const response = await fetch("https://api.wizsearch.in/v1/trendingSearches",
    {
      method: "GET",
      headers: {
        "x-api-key": window.wizzyXAPIKey,
        "x-store-id": window.wizzyStoreID,
      },
    },
  );
  const data = await response.json();
  return data;
}
async function fetchImagesObjectMap(accessToken) {
  const query = `
    query TrendingSearches {
      metaobjects(type: "neo_trending_search", first: 200) {
        edges {
          node {
            fields {
              key
              reference {
                ... on MediaImage {
                  image {
                    height
                    url
                    width
                  }
                }
              }
              type
              value
            }
          }
        }
      }
    }
  `;

  try {
    const response = await fetch("/api/2026-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken,
      },
      body: JSON.stringify({ query }),
    });

    const { data, errors } = await response.json();
    if (errors?.length) {
      console.error("Neo trending searches GraphQL errors:", errors);
      return [];
    }

    const edges = data?.metaobjects?.edges;
    if (!Array.isArray(edges)) {
      return [];
    }

    return edges
      .map((edge) => {
        const fields = edge?.node?.fields;
        if (!Array.isArray(fields)) return null;

        const queryField = fields.find((field) =>
          ["query", "title", "keyword", "search_term"].includes(field?.key),
        );
        const imageField =
          fields.find((field) =>
            ["image", "svg", "icon"].includes(field?.key),
          ) || fields.find((field) => field?.reference?.image);

        const image = imageField?.reference?.image;
        const imageSrc = image?.url || image?.src || "";
        const queryValue = String(queryField?.value || "").trim();

        if (!queryValue || !imageSrc) return null;

        return {
          query: queryValue,
          image: {
            height: image.height ?? null,
            src: imageSrc,
            width: image.width ?? null,
          },
        };
      })
      .filter(Boolean);
  } catch (error) {
    console.error("Neo trending searches metaobject fetch failed:", error);
    return [];
  }
}

async function getTrendingProducts(accessToken) {
  const productFields = `
    id
    handle
    title
    priceRange {
      minVariantPrice { amount }
    }
    variants(first: 1) {
      edges {
        node {
          id
          sku
          barcode
          price { amount }
          compareAtPrice { amount }
          selectedOptions { name value }
        }
      }
    }
    images(first: 1) {
      nodes {
        url
        altText
      }
    }
    style_number: metafield(namespace: "custom", key: "style_number") { value }
    second_subcategory: metafield(namespace: "custom", key: "second_subcategory") { value }
    child_category: metafield(namespace: "custom", key: "child_category") { value }
    bulk_box_material_code: metafield(namespace: "custom", key: "bulk_box_material_code") { value }
    sap_material_code: metafield(namespace: "custom", key: "sap_material_code") { value }
    jockey_collection: metafield(namespace: "custom", key: "jockey_collection") { value }
    product_color_name: metafield(namespace: "custom", key: "product_color_name") { value }
    colour_family: metafield(namespace: "custom", key: "colour_family") { value }
    color_variant: metafield(namespace: "custom", key: "color_variant") { value }
    select_size_guide: metafield(namespace: "custom", key: "select_size_guide") { value }
    parent_category: metafield(namespace: "custom", key: "parent_category") { value }
    second_subcategory: metafield(namespace: "custom", key: "second_subcategory") { value }
    child_category: metafield(namespace: "custom", key: "child_category") { value }
    bulk_box_material_code: metafield(namespace: "custom", key: "bulk_box_material_code") { value }
    sap_material_code: metafield(namespace: "custom", key: "sap_material_code") { value }
    jockey_collection: metafield(namespace: "custom", key: "jockey_collection") { value }
    product_color_name: metafield(namespace: "custom", key: "product_color_name") { value }
    colour_family: metafield(namespace: "custom", key: "colour_family") { value }
  `;

  const query = `
    query NeoTrendingProducts {
      metaobjects(type: "neo_trending_products", first: 1) {
        nodes {
          field(key: "products") {
            value
            references(first: 20) {
              nodes {
                ... on Product {
                  ${productFields}
                }
              }
            }
          }
        }
      }
    }
  `;

  try {
    const response = await fetch("/api/2026-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken,
      },
      body: JSON.stringify({ query }),
    });

    const { data, errors } = await response.json();

    if (errors?.length) {
      console.error("Neo trending products GraphQL errors:", errors);
      return [];
    }

    const productsField = data?.metaobjects?.nodes?.[0]?.field;
    const productsFromReferences =
      productsField?.references?.nodes?.filter(
        (product) => product?.id && product?.handle,
      ) ?? [];

    if (productsFromReferences.length) {
      return productsFromReferences;
    }

    const productIds = parseTrendingProductIds(productsField?.value);
    if (!productIds.length) return [];

    let trendingProducts = await fetchTrendingProductsByIds(accessToken, productIds, productFields);
    return trendingProducts;
  } catch (error) {
    console.error("Neo trending products fetch failed:", error);
    return [];
  }
}

function parseTrendingProductIds(value) {
  if (!value) return [];

  try {
    const parsed = JSON.parse(value);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id) =>
      String(id).includes("gid://shopify/Product/"),
    );
  } catch {
    return [];
  }
}

async function fetchTrendingProductsByIds(accessToken, ids, productFields) {
  const query = `
    query TrendingProductsByIds($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          ${productFields}
        }
      }
    }
  `;

  const response = await fetch("/api/2026-01/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": accessToken,
    },
    body: JSON.stringify({ query, variables: { ids } }),
  });

  const { data, errors } = await response.json();

  if (errors?.length) {
    console.error("Neo trending products by IDs GraphQL errors:", errors);
    return [];
  }

  return (data?.nodes ?? []).filter(
    (product) => product?.id && product?.handle,
  );
}

function findSvg(data, title) {
  const searchTitle = String(title || "").trim().toLowerCase();
  if (!searchTitle || !Array.isArray(data)) return "";

  const exactMatch = data.find(
    (item) => String(item?.query || "").trim().toLowerCase() === searchTitle,
  );
  if (exactMatch?.image?.src) return exactMatch.image.src;

  return (
    data.find((item) => {
      const itemQuery = String(item?.query || "").trim().toLowerCase();
      if (!itemQuery) return false;
      return itemQuery.includes(searchTitle) || searchTitle.includes(itemQuery);
    })?.image?.src || ""
  );
}

let trendingSearchesMeta = [];

function appendMappedSearchIcon(parentSpan, title) {
  let svg = findSvg(trendingSearchesMeta, title);
  if (!svg) return;
  const img = document.createElement("img");
  img.src = svg;
  img.onerror = () => {
    img.style.opacity = "0";
  };
  parentSpan.appendChild(img);
}

function retunTrenidngSeasrchesLisHTML(map) {
  return [...map.entries()]
    .slice(0, 8)
    .map(([title, svg], index) => {
      const label = title.charAt(0).toUpperCase() + title.slice(1);
      const icon = svg
        ? `<img src="${svg}" alt="" onerror="this.style.opacity='0'">`
        : "";
      return `
        <li style="--animation-delay: ${index * 0.1}s;">
          <a href="/search?q=${encodeURIComponent(title)}">
            <span>${icon}</span><p>${label}</p>
          </a>
        </li>`;
    })
    .join("");
}

function renderTrendingSearches(data) {
  const trendingSearches = document.getElementById("trending-searches");
  if (!trendingSearches) return;
  let targetUl = trendingSearches.querySelector("ul");
  targetUl.innerHTML = retunTrenidngSeasrchesLisHTML(data);
}

const RECENT_SEARCHES_KEY = "neo_search_query_params_history";
const MAX_RECENT_SEARCHES = 5;

function getRecentSearches() {
  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
    const parsed = stored ? JSON.parse(stored) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map((entry) => String(entry || "").trim())
      .filter(Boolean)
      .slice(-MAX_RECENT_SEARCHES)
      .reverse();
  } catch {
    return [];
  }
}

function setRecentSearches(searches) {
  try {
    localStorage.setItem(
      RECENT_SEARCHES_KEY,
      JSON.stringify(searches.slice(0, MAX_RECENT_SEARCHES)),
    );
  } catch (error) {
    console.error("Failed to update recent searches:", error);
  }
}

function buildRecentSearchesHTML(list) {
  return list
    .slice(0, MAX_RECENT_SEARCHES)
    .map((term, index) => {
      const value = String(term || "").trim();
      if (!value) return "";
      const encoded = encodeURIComponent(value);
      const label =
        value.charAt(0).toUpperCase() + value.slice(1);
      const escapedLabel = escapeTrendingProductHtml(label);
      const escapedValue = escapeTrendingProductHtml(value);
      const iconSrc = findSvg(trendingSearchesMeta, value);
      const icon = iconSrc
        ? `<img src="${iconSrc}" alt="" onerror="this.style.opacity='0'">`
        : "";
      return `
        <li style="--animation-delay: ${index * 0.1}s;">
          <a href="/search?q=${encoded}" data-recent-query="${escapedValue}">
            <span>${icon}</span>
            <p>${escapedLabel}</p>
            <button
              type="button"
              class="recent-search-remove"
              aria-label="Remove ${escapedLabel}"
              data-recent-remove="${escapedValue}"
            >
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
              </svg>
            </button>
          </a>
        </li>`;
    })
    .join("");
}

function renderRecentSearches() {
  const recentSearchesSection = document.getElementById("recent-searches");
  if (!recentSearchesSection) return;
  const recentList = recentSearchesSection.querySelector(".recent-search-pills");
  if (!recentList) return;

  const searches = getRecentSearches();
  if (!searches.length) {
    recentSearchesSection.hidden = true;
    recentList.innerHTML = "";
    return;
  }

  recentList.innerHTML = buildRecentSearchesHTML(searches);
  recentSearchesSection.hidden = false;
}

function setupRecentSearchesEvents() {
  const recentSearchesSection = document.getElementById("recent-searches");
  if (!recentSearchesSection || recentSearchesSection.dataset.bound === "true") {
    return;
  }
  recentSearchesSection.dataset.bound = "true";

  recentSearchesSection.addEventListener("click", (event) => {
    const removeButton = event.target.closest("[data-recent-remove]");
    if (!removeButton) {
      const link = event.target.closest("a[data-recent-query]");
      if (!link || typeof recentSearchClick !== "function") return;
      const links = recentSearchesSection.querySelectorAll("a[data-recent-query]");
      // Synchronous: the pill is a link that navigates away.
      recentSearchClick({
        recentSearchTerm: link.dataset.recentQuery || "",
        position: Array.from(links).indexOf(link) + 1,
      });
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const value = removeButton.dataset.recentRemove || "";
    const normalized = value.trim().toLowerCase();
    if (!normalized) return;

    try {
      const stored = JSON.parse(
        localStorage.getItem(RECENT_SEARCHES_KEY) || "[]",
      );
      const history = Array.isArray(stored) ? stored : [];
      const updatedSearches = history.filter(
        (item) => String(item || "").trim().toLowerCase() !== normalized,
      );
      setRecentSearches(updatedSearches);
    } catch (error) {
      console.error("Failed to remove recent search:", error);
    }

    renderRecentSearches();
  });
}

function setupTrendingSearchGtmTracking() {
  const container = document.getElementById("trending-searches");
  if (!container || container.dataset.gtmBound === "true") return;
  container.dataset.gtmBound = "true";

  container.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!link) return;

    const trendSearch = link.querySelector("p")?.textContent?.trim() || "";
    const position = Array.from(container.querySelectorAll("a")).indexOf(link) + 1;
    // Synchronous: the chip is a link that navigates away.
    trendSearchClick({ searchTerm: getSearchQueryValue(), trendSearch, position });
  });
}

// TRENDING PRODUCTS
const DUMMY_TRENDING_PRODUCT = {
  id: "8123456789012",
  handle: "high-coverage-soft-microfiber-elastane-full-coverage-support-bra",
  title: "High Coverage Soft Microfiber Elastane Full Coverage Support Bra",
  styleNumber: "#1250",
  price: 499,
  variantId: "4412345678901",
  colorVariantIds: "8123456789012,8123456789013",
  sizeGuideId: "",
  image: {
    src: "https://jockey-in.myshopify.com/cdn/shop/products/MV15_WHITE_0103_S123_JKY_5.webp?v=1700035345",
    alt: "High Coverage Soft Microfiber Elastane Full Coverage Support Bra",
  },
};

function formatTrendingProductPrice(amount) {
  const price = Number.parseFloat(amount);
  if (Number.isNaN(price)) return "₹0.00";
  return `₹${price.toFixed(2)}`;
}

function getTrendingProductImageUrl(src, width) {
  if (!src) return "";
  const separator = src.includes("?") ? "&" : "?";
  return `${src}${separator}width=${width}`;
}

function escapeTrendingProductHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/**
 * Normalizes a trending-product metafield to a single string for GTM/card data.
 *
 * Storefront GraphQL always returns `{ value }` as a string. List metafields
 * serialize that string as JSON (e.g. `["Men"]`); this helper takes the first item.
 *
 * Expected `custom.*` formats (from `/api/.../graphql.json`):
 * - parent_category        string          e.g. "Men"
 * - second_subcategory     string          e.g. "Innerwear"
 * - child_category         string          e.g. "Briefs"
 * - style_number           string          e.g. "#1250"
 * - product_color_name     string          e.g. "White"
 * - colour_family          string          e.g. "White"
 * - sap_material_code      string          e.g. "MAT123"
 * - select_size_guide      string (GID)    metaobject reference
 * - bulk_box_material_code string or JSON array  e.g. "ABC" or `["ABC"]`
 * - jockey_collection      JSON array      e.g. `["Core"]` (list metafield)
 *
 * Also accepts:
 * - missing / null / "" → ""
 * - already-normalized string (dummy products, Wizzy fields) → as-is
 *
 * @param {string|{value?: unknown}|null|undefined} field
 * @returns {string}
 */
function getMetafieldValue(field) {
  if (field == null || field === "") return "";
  if (typeof field === "string") return field;
  const raw = field.value;
  if (raw == null || raw === "") return "";
  if (Array.isArray(raw)) return String(raw[0] ?? "");
  const str = String(raw);
  if (str.startsWith("[")) {
    try {
      const parsed = JSON.parse(str);
      if (Array.isArray(parsed)) return String(parsed[0] ?? "");
    } catch (error) {
      console.error("getMetafieldValue: failed to parse metafield JSON", str, error);
    }
  }
  return str;
}

function getVariantSize(variant) {
  const sizeOption = variant?.selectedOptions?.find(
    (option) => String(option?.name || "").toLowerCase() === "size",
  );
  return sizeOption?.value || variant?.title || "";
}

function normalizeTrendingProduct(product) {
  const productId = String(product.id || "").replace(
    "gid://shopify/Product/",
    "",
  );

  const firstVariant =
    product.selectedOrFirstAvailableVariant ||
    product.variants?.edges?.[0]?.node ||
    product.variants?.nodes?.[0];
  const variantId = String(
    product.variantId || firstVariant?.id || "",
  ).replace("gid://shopify/ProductVariant/", "");

  let colorVariantIds = product.colorVariantIds || "";
  if (!colorVariantIds && product.color_variant?.value) {
    try {
      colorVariantIds = JSON.parse(product.color_variant.value)
        .map((id) => id.split("/").pop())
        .join(",");
    } catch {
      colorVariantIds = "";
    }
  }
 
  const primaryImage = product.image || product.images?.nodes?.[0];
  const imageSrc =
    primaryImage?.src || primaryImage?.url || product.mainImage || "";

  return {
    id: productId,
    handle: product.handle || "",
    title: product.title || "",
    styleNumber: product.styleNumber || getMetafieldValue(product.style_number),
    price:
      product.price ??
      product.priceRange?.minVariantPrice?.amount ??
      firstVariant?.price?.amount ??
      0,
    variantId,
    colorVariantIds,
    sizeGuideId:
      product.sizeGuideId || getMetafieldValue(product.select_size_guide),
    parentCategory:
      product.parentCategory || getMetafieldValue(product.parent_category),
    secondSubCategory:
      product.secondSubCategory || getMetafieldValue(product.second_subcategory),
    childCategory:
      product.childCategory || getMetafieldValue(product.child_category),
    bulkBoxMaterialCode:
      product.bulkBoxMaterialCode ||
      getMetafieldValue(product.bulk_box_material_code),
    sapMaterialCode:
      product.sapMaterialCode || getMetafieldValue(product.sap_material_code),
    jockeyCollection:
      product.jockeyCollection || getMetafieldValue(product.jockey_collection),
    productColorName:
      product.productColorName || getMetafieldValue(product.product_color_name),
    colourFamily:
      product.colourFamily || getMetafieldValue(product.colour_family),
    productSize: product.productSize || getVariantSize(firstVariant),
    productBarcode: product.productBarcode ?? firstVariant?.barcode ?? null,
    variantSKU: product.variantSKU || firstVariant?.sku || "",
    image: {
      src: imageSrc,
      alt:
        primaryImage?.altText ||
        primaryImage?.alt ||
        product.title ||
        "",
    },
  };
}

function getAutocompleteAttrValue(product, attrId) {
  const attr = product?.attributes?.find((item) => item.id === attrId);
  return attr?.values?.[0]?.value?.[0] ?? "";
}

function getAutocompleteColorVariantIds(product) {
  const attr = product?.attributes?.find(
    (item) => item.id === "product_color_variant_custom",
  );
  if (!attr?.values?.length) return "";
  return attr.values
    .map((value) => value?.variationId)
    .filter(Boolean)
    .join(",");
}

function normalizeAutocompleteProduct(product) {
  const handleFromUrl = /\/products\/([^/?#]+)/.exec(
    String(product?.url || ""),
  )?.[1];

  return {
    id: String(product?.groupId ?? ""),
    handle: getAutocompleteAttrValue(product, "product_handle") || handleFromUrl || "",
    title: product?.name || "",
    styleNumber: getAutocompleteAttrValue(product, "product_style_number_custom"),
    price: product?.sellingPrice ?? product?.finalPrice ?? product?.price ?? 0,
    variantId: String(product?.id ?? ""),
    colorVariantIds: getAutocompleteColorVariantIds(product),
    sizeGuideId: getAutocompleteAttrValue(product, "product_select_size_guide_custom"),
    image: {
      src: product?.mainImage || product?.images?.[0] || product?.hoverImage || "",
      alt: product?.name || "",
    },
  };
}

function generateSearchTrendingProductCardHTML(product, index = 0) {
  const normalized = normalizeTrendingProduct(product);
  const gtmData = buildTrendingGtmProductData(normalized, product);
  return buildProductCardHTML(normalized, index, gtmData);
}

function buildTrendingGtmProductData(normalized, product = {}, searchTerm) {
  const firstVariant =
    product.variants?.edges?.[0]?.node || product.variants?.nodes?.[0];
  const sizeOption = firstVariant?.selectedOptions?.find((option) =>
    /size/i.test(option?.name || ""),
  );
  const sellingPrice = Number(normalized.price) || 0;

  return {
    parentCategory: product.parent_category?.value || "",
    secondSubCategory: product.second_subcategory?.value || "",
    childCategory: product.child_category?.value || "",
    styleNumber: normalized.styleNumber || "",
    bulkBoxMaterialCode: normalized.bulkBoxMaterialCode || "",
    sapMaterialCode: normalized.sapMaterialCode || "",
    jockeyCollection: normalized.jockeyCollection || "",
    productColorName: normalized.productColorName || "",
    colourFamily: normalized.colourFamily || "",
    productSize: normalized.productSize || "",
    productBarcode: normalized.productBarcode ?? null,
    id: String(normalized.id || ""),
    title: normalized.title || "",
    productImage: normalized.image?.src || "",
    currency: "INR",
    price: sellingPrice,
    mrp: Number(firstVariant?.compareAtPrice?.amount) || sellingPrice,
    variantSKU: firstVariant?.sku || "",
    widgetSection: "Trending",
    searchTerm:
      searchTerm !== undefined ? searchTerm : getSearchQueryValue(),
  };
}

function buildProductCardHTML(normalized, index = 0, gtmData = null) {
  const productUrl = `/products/${normalized.handle}`;
  const mobileImage = getTrendingProductImageUrl(normalized.image.src, 290);
  const desktopImage = getTrendingProductImageUrl(normalized.image.src, 316);
  const fallbackImage = getTrendingProductImageUrl(normalized.image.src, 290);
  const formattedPrice = formatTrendingProductPrice(normalized.price);
  const safeTitle = escapeTrendingProductHtml(normalized.title);
  const safeAlt = escapeTrendingProductHtml(normalized.image.alt);
  const safeStyleNumber = escapeTrendingProductHtml(normalized.styleNumber);
  const gtmAttributes = gtmData
    ? `data-gtm-product-data="${encodeGtmProductData(gtmData)}" data-gtm-autocomplete="true"`
    : "";

  return `
    <div class="mobile-search__trending-product search-trending-card" style="--animation-delay: ${index * 0.1}s;" ${gtmAttributes}>
      <div class="search-trending-card__media">
        <a href="${productUrl}" class="search-trending-card__media-link">
          <picture>
            <source
              media="(min-width: 991px)"
              srcset="${desktopImage}"
              width="158"
              height="181"
            >
            <source
              media="(max-width: 990px)"
              srcset="${mobileImage}"
              width="145"
              height="158"
            >
            <img
              src="${fallbackImage}"
              alt="${safeAlt}"
              width="145"
              height="158"
              loading="lazy"
              draggable="false"
              class="search-trending-card__image motion-reduce media_product"
            >
          </picture>
        </a>
        <div class="search-trending-card__wishlist card_wishlist">
          <span
            class="smartwishlist wishlistcardButton"
            data-product="${normalized.id}"
            data-variant="${normalized.variantId}"
            onclick="wishlistEvent(this)"
          ></span>
        </div>
      </div>
      <div class="search-trending-card__body">
        ${safeStyleNumber ? `<p class="search-trending-card__style productstyleNumber">${safeStyleNumber}</p>` : ""}
        <a href="${productUrl}" class="search-trending-card__title-link">
          <h3 class="search-trending-card__title">${safeTitle}</h3>
        </a>
        <div class="search-trending-card__footer btn_price">
          <div class="search-trending-card__price price">
            <span class="price-item price-item--regular product_price">${formattedPrice}</span>
          </div>
          <button
            type="button"
            class="cloneBtn search-trending-card__atb"
            onclick="ATBModalOpen(event, '${normalized.id}', '${normalized.colorVariantIds}', '${normalized.sizeGuideId}', 'custom-search-modal')"
            aria-label="Add to bag"
          >
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="add-to-bag-svg" aria-hidden="true">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2988 3.93606C11.2988 1.90046 9.60755 0.231445 7.5405 0.231445C5.47345 0.231445 3.7823 1.90053 3.7823 3.93593V5.46251H0.859289C0.504293 5.46251 0.23291 5.72707 0.23291 6.07314V15.6398C0.23291 17.3293 1.63178 18.693 3.3648 18.693H8.7463C8.52841 18.3161 8.34935 17.9139 8.21458 17.4919L3.36452 17.492C2.3205 17.492 1.48538 16.6778 1.48538 15.6601V6.70401L3.7823 6.70387V7.76225C3.7823 8.10833 4.05368 8.37289 4.40867 8.37289C4.76367 8.37289 5.03505 8.10833 5.03505 7.76225V6.70387H10.0461V7.76225C10.0461 8.10833 10.3175 8.37289 10.6725 8.37289C11.0275 8.37289 11.2988 8.10833 11.2988 7.76225V6.70387H13.5956V9.48248C13.7547 9.47015 13.9155 9.46387 14.0778 9.46387C14.3388 9.46387 14.5959 9.48011 14.8483 9.51163V6.07314C14.8483 5.72707 14.5769 5.46251 14.2219 5.46251L11.2988 5.46265V3.93606ZM7.5405 1.45243C8.91853 1.45243 10.046 2.57202 10.046 3.93572V5.4623H5.03498V3.93572C5.03498 2.57188 6.16246 1.45243 7.5405 1.45243Z" fill="#fff"/>
              <path d="M14.0773 12.5402C13.6997 12.5402 13.3936 12.8462 13.3936 13.2239V14.9334H11.6841C11.3065 14.9334 11.0004 15.2394 11.0004 15.6171C11.0004 15.9947 11.3065 16.3008 11.6841 16.3008H13.3936V18.0103C13.3936 18.3879 13.6997 18.694 14.0773 18.694C14.455 18.694 14.761 18.3879 14.761 18.0103V16.3008H16.4705C16.8482 16.3008 17.1542 15.9947 17.1542 15.6171C17.1542 15.2394 16.8482 14.9334 16.4705 14.9334H14.761V13.2239C14.761 12.8462 14.455 12.5402 14.0773 12.5402Z" fill="#fff"/>
            </svg>
            <svg class="loading-spinner" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><style>.spinner_aj0A{transform-origin:center;animation:spinner_KYSC .75s infinite linear}@keyframes spinner_KYSC{100%{transform:rotate(360deg)}}</style><path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A"/></svg>
          </button>
        </div>
      </div>
    </div>
  `.trim();
}

let trendingProductsState = [];
let currentProductsRenderKey = "";
let pendingProductsRenderFrame = null;

function getTrendingProductsContainer() {
  return (
    document.getElementById("trending-products-list") ||
    document.querySelector(".mobile-search__trending-products")
  );
}

/**
 * Desktop click-drag horizontal scroll for trending products.
 * - Image / title: drag scrolls; tap/click still goes to PDP (8px threshold).
 * - ATC / wishlist: never start grab — clicks bubble normally.
 * - Touch: native overflow scroll.
 * @param {HTMLElement|null} container
 */
function setupTrendingProductsDragScroll(container) {
  if (!container || container.dataset.dragScrollBound === "true") return;
  container.dataset.dragScrollBound = "true";

  const DRAG_THRESHOLD_PX = 8;
  const NO_DRAG_SELECTOR =
    ".search-trending-card__atb, button, .cloneBtn, .card_wishlist, .wishlistcardButton";

  let isPointerDown = false;
  let pointerId = null;
  let startX = 0;
  let startScrollLeft = 0;
  let hasDragged = false;

  // INP risk: low — scrollLeft + data attrs only; no layout reads.
  container.addEventListener("pointerdown", (event) => {
    if (event.pointerType === "touch") return;
    if (event.button !== 0) return;
    if (event.target.closest(NO_DRAG_SELECTOR)) return;

    isPointerDown = true;
    hasDragged = false;
    pointerId = event.pointerId;
    startX = event.clientX;
    startScrollLeft = container.scrollLeft;
    // ponytail: capture only after threshold so <a> clicks still fire
  });

  container.addEventListener("pointermove", (event) => {
    if (!isPointerDown || event.pointerId !== pointerId) return;

    const dx = event.clientX - startX;
    if (!hasDragged) {
      if (Math.abs(dx) <= DRAG_THRESHOLD_PX) return;
      hasDragged = true;
      container.toggleAttribute("data-dragging", true);
      try {
        container.setPointerCapture(pointerId);
      } catch {
        /* ignore */
      }
    }

    event.preventDefault();
    container.scrollLeft = startScrollLeft - dx;
  });

  const endDrag = (event) => {
    if (!isPointerDown) return;
    if (event?.pointerId != null && pointerId != null && event.pointerId !== pointerId) {
      return;
    }

    isPointerDown = false;
    container.toggleAttribute("data-dragging", false);
    container.toggleAttribute("data-dragged", hasDragged);

    if (pointerId != null) {
      try {
        if (container.hasPointerCapture(pointerId)) {
          container.releasePointerCapture(pointerId);
        }
      } catch {
        /* ignore */
      }
    }
    pointerId = null;
  };

  container.addEventListener("pointerup", endDrag);
  container.addEventListener("pointercancel", endDrag);

  // Block native image/link drag so pointermove keeps firing for scroll.
  container.addEventListener("dragstart", (event) => {
    event.preventDefault();
  });

  // Capture: after a real drag, block the synthetic click (incl. image/title <a>).
  container.addEventListener(
    "click",
    (event) => {
      if (!container.hasAttribute("data-dragged")) return;
      event.preventDefault();
      event.stopPropagation();
      container.removeAttribute("data-dragged");
    },
    true,
  );
}

function setTrendingSectionTitle(text) {
  const heading = document.querySelector(
    ".mobile-search__trending-products-container h2",
  );
  if (!heading) return;

  const textNodes = [...heading.childNodes].filter(
    (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim(),
  );
  if (textNodes.length) {
    textNodes.at(-1).textContent = ` ${text}`;
  } else {
    heading.appendChild(document.createTextNode(` ${text}`));
  }
}

function resetTrendingSectionTitle() {
  const heading = document.querySelector(
    ".mobile-search__trending-products-container h2",
  );
  setTrendingSectionTitle(heading?.dataset.defaultText || "Trending");
}

function getProductCardsHTML(products) {
 
  const list = Array.isArray(products) ? products : [products];
  return list
    .map((product, index) => generateSearchTrendingProductCardHTML(product, index))
    .join("");
}

function scheduleProductsRender(container, renderKey, beforeRender, html) {
  if (!container || currentProductsRenderKey === renderKey) return;

  currentProductsRenderKey = renderKey;
  if (pendingProductsRenderFrame) {
    cancelAnimationFrame(pendingProductsRenderFrame);
  }

  // Batch product DOM writes to the next frame and skip duplicate renders to reduce reflow work.
  pendingProductsRenderFrame = requestAnimationFrame(() => {
    beforeRender?.();
    container.innerHTML = html;
    pendingProductsRenderFrame = null;
  });
}

function renderTrendingProducts(products) {
  const container = getTrendingProductsContainer();
  scheduleProductsRender(container, "trending", null, getProductCardsHTML(products));
}

function restoreTrendingProducts() {
  const container = getTrendingProductsContainer();
  const products = trendingProductsState.length
    ? trendingProductsState
    : [DUMMY_TRENDING_PRODUCT];

  scheduleProductsRender(
    container,
    "trending",
    resetTrendingSectionTitle,
    getProductCardsHTML(products),
  );
}

const getRandomAlphabet = () => String.fromCharCode(97 + Math.floor(Math.random() * 26));

// CUSTOM SEARCH
async function fetchAutoComplete(query = getRandomAlphabet()) {
  const url = "https://api.wizsearch.in/v1/autocomplete";

  const payload = {
    q: query,
    currency: "INR",
    suggestionsCount: 19,
    includeOutOfStock: "true",
    getAllVariants: "false",
    minQueryLength: 3,
    productsCount: 6,
    sections: JSON.stringify([{ key: "others" }, { key: "categories" }]),
    swatch: "",
    sort: "",
    facets: "",
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "U1p4NjVUTitoZDJzK2s2UStBaWZ5R3lvNGw5UEg3bE1XOUxlZTFJLy9PeXdITkZ6eW5HQTFvWEQrTGplTU5mdzdOQmxnYllVN3VQV1lqZW1WZE1hTHc9PQ==",
        "x-store-id": "359bc77004f811ee9f000a0c8095feae",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Autocomplete fetch failed:", error);
    return null;
  }
}

const AUTOCOMPLETE_DEBOUNCE_MS = 800;
const AUTOCOMPLETE_MIN_QUERY_LENGTH = 2;
const SUGGESTIONS_SKELETON_COUNT = 5;
const SKELETON_STYLE_BASE = `
  --skeleton-bg: rgba(170, 170, 170, 0.2);
  --skeleton-shine-color: rgba(255, 255, 255, 0.3);
  --skeleton-animation-duration: 1.2s;
`;

let autocompleteRequestId = 0;
let autocompleteDebounceTimer = null;

const desktopInput = document.getElementById("desktop-search-input");
const desktopClear = document.getElementById("desktop-search-clear");
const desktopSearchForm = document.getElementById("desktop-search-form");
const mobileInput = document.getElementById("mobile-search-input");
const mobileClear = document.getElementById("mobile-search-clear");
const mobileClearGroup = document.getElementById("mobile-search-clear-group");

function getSearchQueryValue() {
  return (mobileInput?.value || desktopInput?.value || "").trim();
}

function syncSearchInputs(source, target) {
  if (source && target && source.value !== target.value) {
    target.value = source.value;
  }
}

function updateSearchSectionsVisibility() {
  const searchBody = document.getElementById("custom-search-body");
  const query = getSearchQueryValue();
  searchBody?.classList.toggle("has-query", query.length > (AUTOCOMPLETE_MIN_QUERY_LENGTH - 1));
}

function getSuggestionsSkeletonHTML(count = SUGGESTIONS_SKELETON_COUNT) {
  return Array.from(
    { length: count },
    (_, index) => `
    <li class="ss-skeleton" style="--animation-delay: ${index * 0.1}s;">
      <skeleton style="
        --skeleton-width: 100%;
        --skeleton-height: auto;
        --skeleton-min-height: 14px;
        --skeleton-radius: 4px;
        ${SKELETON_STYLE_BASE}
      "></skeleton>
    </li>
  `,
  ).join("");
}

function showSuggestionsSkeleton() {
  const suggestionsList = document.querySelector("#search-suggestions ul");
  if (suggestionsList) {
    suggestionsList.innerHTML = getSuggestionsSkeletonHTML();
  }
}

function getSuggestionItemValue(item) {
  return item?.value || item?.label || item?.searchTerm || "";
}

function createSearchSuggestionElement(item, index) {
  const value = getSuggestionItemValue(item);
  const li = document.createElement("li");
  li.style.animationDelay = `${index * 0.1}s`;
  const link = document.createElement("a");
  link.href = `/search?q=${encodeURIComponent(value)}`;
  link.dataset.suggestion = value;

  const iconSpan = document.createElement("span");
  appendMappedSearchIcon(iconSpan, value);
  link.appendChild(iconSpan);

  const labelSpan = document.createElement("span");
  if (item?.valueHighlighted) {
    labelSpan.innerHTML = item.valueHighlighted;
  } else {
    labelSpan.textContent = value;
  }
  link.appendChild(labelSpan);

  li.appendChild(link);
  return li;
}

// Wizzy autocomplete has no spell-correction flag, so infer it: corrected when a typed word
// is not the start of any word in the suggestion (e.g. "brra" -> "Bras for women").
function isSuggestionSpellCorrected(query, suggestion) {
  const suggestionWords = suggestion.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  const queryWords = query.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  return queryWords.some(
    (queryWord) => !suggestionWords.some((word) => word.startsWith(queryWord)),
  );
}

function setupSearchSuggestionsGtmTracking() {
  const container = document.getElementById("search-suggestions");
  if (!container || container.dataset.gtmBound === "true") return;
  container.dataset.gtmBound = "true";

  container.addEventListener("click", (event) => {
    const link = event.target.closest("a[data-suggestion]");
    if (!link || typeof searchSuggestionClick !== "function") return;

    const links = container.querySelectorAll("a[data-suggestion]");
    const searchQuery = getSearchQueryValue();
    const searchTerms = link.dataset.suggestion || "";
    // Synchronous: the suggestion is a link that navigates away.
    searchSuggestionClick({
      searchTerms,
      searchQuery,
      isSpellCorrected: isSuggestionSpellCorrected(searchQuery, searchTerms),
      position: Array.from(links).indexOf(link) + 1,
    });
  });
}

function renderSearchSuggestions(others) {
  const container = document.querySelector("#search-suggestions ul");
  if (!container) return;

  const items = Array.isArray(others) ? others : [];
  const fragment = document.createDocumentFragment();

  items.filter((item) => getSuggestionItemValue(item)).forEach((item, index) => fragment.appendChild(createSearchSuggestionElement(item, index)));

  container.innerHTML = "";
  container.appendChild(fragment);

  // No suggestions for this query: hide the whole section so the heading is not left alone.
  const section = document.getElementById("search-suggestions");
  if (section) section.hidden = !container.children.length;
}

function renderSearchResults(products, queryLength) {
  const list = Array.isArray(products) ? products : (products?.result ?? []);
  const container = getTrendingProductsContainer();
  if (!container) return;

  if (queryLength < 3 || !list.length) {
    restoreTrendingProducts();
    return;
  }

  const searchTerm = getSearchQueryValue();
  const renderKey = `search:${searchTerm}:${list
    .map((product) =>
      product?.id || product?.groupId || product?.url || product?.name || "",
    )
    .join("|")}`;
  const html = list
    .map((product, index) => {
      const normalized = normalizeAutocompleteProduct(product);
      const gtmData = {
        ...buildWizzyGtmProductData(product, searchTerm),
        widgetSection: "Popular Results",
      };
      return buildProductCardHTML(normalized, index, gtmData);
    })
    .join("");

  scheduleProductsRender(
    container,
    renderKey,
    () => {
      setTrendingSectionTitle("Popular Results");
    },
    html,
  );
}

function clearSuggestionsResults() {
  // Query cleared: bring the section back so the next search starts with the skeleton.
  const section = document.getElementById("search-suggestions");
  if (section) section.hidden = false;
  showSuggestionsSkeleton();
}

async function runAutocompleteSearch() {
  const query = getSearchQueryValue();

  if (query.length === 0) {
    clearSuggestionsResults();
    restoreTrendingProducts();
    return;
  }

  if (query.length < AUTOCOMPLETE_MIN_QUERY_LENGTH) {
    showSuggestionsSkeleton();
    return;
  }

  showSuggestionsSkeleton();

  const requestId = ++autocompleteRequestId;
  const data = await fetchAutoComplete(query);

  if (requestId !== autocompleteRequestId) return;

  if (!data?.payload) {
    showSuggestionsSkeleton();
    renderSearchResults([], query.length);
    return;
  }

  renderSearchSuggestions(data.payload.others ?? []);
  renderSearchResults(data.payload.products ?? [], query.length);
}

function scheduleAutocompleteSearch() {
  clearTimeout(autocompleteDebounceTimer);
  autocompleteDebounceTimer = window.setTimeout(() => {
    void runAutocompleteSearch();
  }, AUTOCOMPLETE_DEBOUNCE_MS);
}

function getSearchResultsUrl(query) {
  const params = new URLSearchParams({
    q: query,
    "options[prefix]": "last",
  });
  return `/search?${params.toString()}`;
}

function handleSearchFormSubmit(event) {
  event.preventDefault();

  const query = getSearchQueryValue();
  if (!query) return;

  // Tell the results page this search was typed (read by search_zero_result).
  if (typeof setNeoSearchOrigin === "function") setNeoSearchOrigin("typed", query);
  window.location.assign(getSearchResultsUrl(query));
}

function setupSearchFormSubmission() {
  const forms = [
    document.getElementById("desktop-search-form"),
    document.getElementById("mobile-search-form"),
  ].filter(Boolean);

  forms.forEach((form) => {
    form.addEventListener("submit", handleSearchFormSubmit);
  });
}

function clearSearchInput(input) {
  if (!input) return;
  input.value = "";
  setTimeout(() => {
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.focus();
  }, 0);
}

function updateDesktopSearchClearButton() {
  const hasDesktopValue = Boolean(desktopInput?.value.length);

  if (desktopClear) desktopClear.hidden = !hasDesktopValue;
  if (mobileClearGroup) mobileClearGroup.hidden = !mobileInput?.value.length;
  desktopSearchForm?.classList.toggle("is-clear-visible", hasDesktopValue);
}

function setupDesktopSearchClearButton() {
  desktopClear?.addEventListener("click", () => clearSearchInput(desktopInput));
  mobileClear?.addEventListener("click", () => clearSearchInput(mobileInput));
  updateDesktopSearchClearButton();
}

function setupSearchInputAutocomplete() {
  const inputs = [mobileInput, desktopInput].filter(Boolean);

  const handleSearchInput = (source) => {
    if (source === mobileInput) {
      syncSearchInputs(mobileInput, desktopInput);
    } else if (source === desktopInput) {
      syncSearchInputs(desktopInput, mobileInput);
    }

    // Hide suggestions right away; renderSearchSuggestions shows them again only if the API returns some.
    if (getSearchQueryValue().length > 0) {
      const suggestions = document.getElementById("search-suggestions");
      if (suggestions) suggestions.hidden = true;
    }

    updateSearchSectionsVisibility();
    updateDesktopSearchClearButton();
    scheduleAutocompleteSearch();
  };

  inputs.forEach((input) => {
    input.addEventListener("input", () => handleSearchInput(input));
  });
}

function prefillSearchFromUrl() {
  const query = new URLSearchParams(window.location.search).get("q");
  if (!query) return;

  if (mobileInput) mobileInput.value = query;
  if (desktopInput) desktopInput.value = query;

  updateSearchSectionsVisibility();
  updateDesktopSearchClearButton();
  void runAutocompleteSearch();
}

(async function initCustomSearch() {
  setupSearchFormSubmission();
  setupSearchInputAutocomplete();
  setupDesktopSearchClearButton();
  prefillSearchFromUrl();

  // Show recent searches from localStorage immediately (section stays hidden if empty)
  renderRecentSearches();
  setupRecentSearchesEvents();
  setupSearchSuggestionsGtmTracking();

  // Fetch trending searches
  const trendingSearches = await fetchTrendingSearches();

  // fetch and store MF in window
  let trendingSearchesMF = [];
  try {
    trendingSearchesMF = await fetchImagesObjectMap(
      window.storefrontAccessToken,
    );
  } catch (error) {
    console.error("Neo trending searches icon map failed:", error);
  }
  trendingSearchesMeta = trendingSearchesMF ?? [];

  // create a map
  let trendingSearchesMap = new Map();
  trendingSearches.payload.queries.forEach((title) => {
    let svg = findSvg(trendingSearchesMF, title);
    trendingSearchesMap.set(title, svg);
  });

  // render trending searches
  renderTrendingSearches(trendingSearchesMap);
  setupTrendingSearchGtmTracking();
  // Re-render recent pills after icon meta is available
  renderRecentSearches();

  // render trending product cards from Neo Trending Products metaobject
  const trendingProducts = await getTrendingProducts(
    window.storefrontAccessToken,
  );
  trendingProductsState = trendingProducts.length
    ? trendingProducts
    : [DUMMY_TRENDING_PRODUCT];
  renderTrendingProducts(trendingProductsState);
  setupTrendingProductsDragScroll(getTrendingProductsContainer());
})();
